import TextField from '@mui/material/TextField';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';

const FieldEditor = ({ fieldType, value, onChange, readOnly = false }) => {
  const val = value ?? '';

  switch (fieldType) {
    case 'boolean':
      return (
        <FormControlLabel
          control={
            <Switch
              checked={!!val}
              onChange={(e) => onChange(e.target.checked)}
              disabled={readOnly}
              size="small"
            />
          }
          label={val ? 'Yes' : 'No'}
        />
      );

    case 'number':
    case 'dimension':
    case 'weight':
      return (
        <TextField
          type="number"
          size="small"
          value={val}
          onChange={(e) => onChange(e.target.value)}
          disabled={readOnly}
          fullWidth
          inputProps={{ step: fieldType === 'number' ? 'any' : '0.01' }}
        />
      );

    case 'date':
      return (
        <TextField
          type="date"
          size="small"
          value={val}
          onChange={(e) => onChange(e.target.value)}
          disabled={readOnly}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      );

    case 'color':
      return (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <input
            type="color"
            value={val || '#000000'}
            onChange={(e) => onChange(e.target.value)}
            disabled={readOnly}
            style={{ width: 40, height: 32, border: 'none', cursor: readOnly ? 'default' : 'pointer' }}
          />
          <TextField
            size="small"
            value={val}
            onChange={(e) => onChange(e.target.value)}
            disabled={readOnly}
            placeholder="#000000"
            sx={{ flex: 1 }}
          />
        </Box>
      );

    case 'url':
      return (
        <TextField
          type="url"
          size="small"
          value={val}
          onChange={(e) => onChange(e.target.value)}
          disabled={readOnly}
          fullWidth
          placeholder="https://..."
        />
      );

    case 'rich_text':
    case 'json':
      return (
        <TextField
          multiline
          rows={4}
          size="small"
          value={typeof val === 'object' ? JSON.stringify(val, null, 2) : val}
          onChange={(e) => onChange(e.target.value)}
          disabled={readOnly}
          fullWidth
          sx={{ '& .MuiInputBase-root': { fontFamily: fieldType === 'json' ? 'monospace' : 'inherit' } }}
        />
      );

    case 'image':
      return (
        <TextField
          size="small"
          value={val}
          onChange={(e) => onChange(e.target.value)}
          disabled={readOnly}
          fullWidth
          placeholder="Image URL"
        />
      );

    default: // text
      return (
        <TextField
          size="small"
          value={val}
          onChange={(e) => onChange(e.target.value)}
          disabled={readOnly}
          fullWidth
        />
      );
  }
};

export default FieldEditor;
